import { createSlice } from "@reduxjs/toolkit";
import { fetchJobs } from "../thunks/fetch-jobs-thunk";

const initialState = {
    jobs: [],
    departments: [],
    divisions: [],
    lookup: null,
    status: "idle",
    error: null,
};

export const jobsSlice = createSlice({
    name: "jobsSlice",
    initialState,
    reducers: {
        resetJobs: (state) => {
            state.jobs = [];
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.jobs = action.payload.jobs;
                state.departments = action.payload.departments;
                state.divisions = action.payload.divisions;
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    },
});

export const selectJobList = (state) => state.jobsSlice.jobs;
export const selectDepartment = (state) => state.jobsSlice.departments;
export const selectDivisions = (state) => state.jobsSlice.divisions;
export const selectJobsError = (state) => state.jobsSlice.error;
export const selectJobsStatus = (state) => state.jobsSlice.status;
